import { useCompassContext } from "@circleco/compass/context/CompassContext";
import { CompassProvider } from "@circleco/compass/context/CompassProvider";
import NiceModal, { useModal as useNiceModal } from "@ebay/nice-modal-react";
import type { ReactNode } from "react";

export const ModalManager = NiceModal;

export const useModal = useNiceModal;

interface DrawerProviderProps {
  children: ReactNode;
}

export const ModalManagerProvider = ({ children }: DrawerProviderProps) => {
  const compassContext = useCompassContext();

  const content = <ModalManager.Provider>{children}</ModalManager.Provider>;

  // Skip wrapping in CompassProvider when already inside one
  if (compassContext) {
    return content;
  }

  return <CompassProvider>{content}</CompassProvider>;
};
